import { SvgIconType } from './svg.interface';

const Clipboard: SvgIconType = ({
  width = 12,
  height = 12,
  className = ''
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4.5 1.5C4.5 0.671573 5.17157 0 6 0C6.82843 0 7.5 0.671573 7.5 1.5C7.5 1.91421 7.16421 2.25 6.75 2.25H5.25C4.83579 2.25 4.5 1.91421 4.5 1.5Z"
      fill="#6A7383"
    />
    <path
      d="M9 1.5C9 2.74264 7.99264 3.75 6.75 3.75H5.25C4.00736 3.75 3 2.74264 3 1.5C2.17157 1.5 1.5 2.17157 1.5 3V10.5C1.5 11.3284 2.17157 12 3 12H9C9.82843 12 10.5 11.3284 10.5 10.5V3C10.5 2.17157 9.82843 1.5 9 1.5Z"
      fill="#6A7383"
    />
  </svg>
);

export default Clipboard;
